import LoadingButton from "@mui/lab/LoadingButton";
import "./question.scss";
import {
  RequestNextStage,
  GetAllstageswithstsatus,
  MarkDocumentRead,
} from "../../utils/Api/api";
import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import parser from "html-react-parser";
import { ChangeEvent, useContext, useEffect, useState } from "react";
import Pie from "../../components/Pie/pie";
import { toast } from "react-toastify";
import { toastCommonestyle } from "../../utils/Toast";
import { useNavigate } from "react-router-dom";
import { Context } from "../../contextApi/contextProvider";
import { ShimmerLoaderwhite } from "../../utils/loader/ShimmerLoader";
import { getPostStatus, isPostIdPresent } from "../../utils/isPostIdPresent";
import { cmsPrivateContent } from "../../utils/cmscontent/cms";
import { AccessDOCOBJ } from "../../components/Navbar/Navbar";
import { getDocumentSection } from "../../pages/PPMContent/Intro";


export interface Stage {
  stage_uid: string;
  stage_name: string;
  stage_priority: string;
  stage_status: string | "";
  documents?: {
    post_id: string;
    post_name: string;
    document_status: string;
  }[];
}
const Question = () => {
  const loaction = useGeoLocation();
  const navigator = useNavigate();
  const MAX_LENGTH = 300;
  const containsMaliciousCharacters = (val: string) =>
    ["<", ">", '"', "'", "`", "=", "{", "}", "(", ")"].some((char) =>
      val.includes(char)
    ) || val.toLowerCase().includes("script");
  const { userLoginData, setUserLoginData, accessDoc, setAccessDoc } =
    useContext(Context);
  const [currentStatus, setCurrentStatus] = useState({
    name: "",
    status: "",
    uid: "",
  });
  const [btnLoading, setBtnLoading] = useState(false);
  const [htmlString, setHtmlStr] = useState<string[]>([]);
  const [removeHtml, setHtmlRemove] = useState<string[]>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [value, setValue] = useState(0);
  const [questionObj, setQuestionObj] = useState<{ [key: string]: string }>({});
  const [isFormComplete, setIsFormComplete] = useState(false); // Track if form is complete
  const token = JSON.parse(localStorage.getItem("access_token") as string);

  const getDocumentStatusByPostId = (
    stages: Stage[],
    stage_name: string
  ): string | undefined => {
    return stages
      .find((stage) => stage.stage_name.trim() === stage_name)
      ?.stage_status.trim();
  };

  useEffect(() => {
    const nonEmptyFields = countNonEmptyValues(questionObj);
    setIsFormComplete(nonEmptyFields === removeHtml.length);
    let sum = countNonEmptyValues(questionObj);
    setValue((sum / removeHtml.length) * 100);
  }, [questionObj, removeHtml]);

  const countNonEmptyValues = (surveyData: {
    [key: string]: string;
  }): number => {
    return Object.keys(surveyData).reduce((count, key) => {
      const value = surveyData[key]?.trim();
      return count + (value ? 1 : 0);
    }, 0);
  };

  const handleChange = (
    event: ChangeEvent<HTMLTextAreaElement>,
    no: number
  ) => {
    const fieldKey = removeHtml[no];
    const val = event.target.value;

    let errorMessage = "";

    if (val.length > MAX_LENGTH) {
      errorMessage = `Maximum ${MAX_LENGTH} characters allowed.`;
    }

    if (!errorMessage && containsMaliciousCharacters(val)) {
      errorMessage = "Invalid characters detected.";
    }

    setErrors((prev) => ({ ...prev, [fieldKey]: errorMessage }));

    if (!errorMessage) {
      setQuestionObj((prev) => ({ ...prev, [fieldKey]: val }));
    } else {
      setQuestionObj((prev) => ({ ...prev, [fieldKey]: "" }));
    }
  };
  const getTalk = async () => {
    try {
      const response = await GetAllstageswithstsatus({
        ip_address: await userLoginData.ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
      });

      if (response?.data) {
        const financialProjectionStage = await getDocumentStatusByPostId(
          response?.data?.all_stage_info,
          "Stage 2 - Evaluation"
        );

        setAccessDoc(response?.data);
        const updatedAccessDOCOBJ: AccessDOCOBJ = { ...accessDoc };
        Object.keys(updatedAccessDOCOBJ).forEach((key) => {
          const status = getPostStatus(key, response?.data?.all_stage_info);
          updatedAccessDOCOBJ[key] = status;
        });
        setAccessDoc({
          ...updatedAccessDOCOBJ,
          all_stage_info: response?.data?.all_stage_info,
        });

        if (financialProjectionStage) {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
          fetchCmsContent();
        } else {
          setCurrentStatus({
            name: "",

            uid: "",
            status: financialProjectionStage || "",
          });
          fetchCmsContent();
        }
      }
    } catch (error) {
      toast.error("Something went wrong", toastCommonestyle as any);
    }
  };
  const nextStage = async () => {
    setCurrentStatus({
      name: "",
      status: "",
      uid: "",
    });
    try {
      const { data } = await RequestNextStage({
        ip_address: await userLoginData.ip,
        latitude: await loaction.coordinates.lat,
        longitude: await loaction.coordinates.lng,
        section_id: await getDocumentSection(
          accessDoc?.all_stage_info as Stage[],
          "Stage 2 - Evaluation"
        ),
        ques_and_ans: JSON.stringify(questionObj),
      });

      if (data.status == 200) {
        getTalk();
        toast.success(data.message, toastCommonestyle as any);
      } else {
        setCurrentStatus(data);
      }
      setBtnLoading(false);
    } catch (error) {
      setBtnLoading(false);
      toast.error("Something went wrong", toastCommonestyle as any);
      setQuestionObj({});
    }
  };
  const handleSubmit = async () => {
    if (btnLoading) return;
    setBtnLoading(true);
    nextStage();
  };
  const readDoc = async () => {
    try {
      const { data } = await MarkDocumentRead({
        ip_address: await userLoginData.ip,
        latitude: loaction.coordinates?.lat ?? "0.0",
        longitude: loaction.coordinates?.lng ?? "0.0",
        post_id: "7033",
      });
    } catch (error) {}
  };
  const fetchCmsContent = async () => {
    const response = await cmsPrivateContent({
      post_id: "7033",
      lat: loaction.coordinates.lat,
      log: loaction.coordinates.lng,
    });
    setHtmlStr(response);
  };
  useEffect(() => {
    if (userLoginData.status == 200 && accessDoc["7033"] !== "de") {
      if (accessDoc["7033"] == "ALLOWED") {
        readDoc();
        if (accessDoc?.all_stage_info) {
          const financialProjectionStage = getDocumentStatusByPostId(
            accessDoc?.all_stage_info as Stage[],
            "Stage 2 - Evaluation"
          );
          if (financialProjectionStage) {
            setCurrentStatus({
              name: "",

              uid: "",
              status: financialProjectionStage || "",
            });
            fetchCmsContent();
          } else {
            setCurrentStatus({
              name: "",

              uid: "",
              status: financialProjectionStage || "",
            });
            fetchCmsContent();
          }
        }
      } else {
        navigator("/");
      }
    } else if (userLoginData.status == 404) {
      navigator("/");
    } else if (token === "" || token === null || token === undefined) {
      navigator("/");
    }
    window.scrollTo(0, 0);
    document.title = "TICCA | Question";
  }, [userLoginData.status, accessDoc]);
  function removeHTMLTags(str: string): string {
    const doc = new DOMParser().parseFromString(str, "text/html");
    let cleanedStr = doc.body.textContent || "";
    cleanedStr = cleanedStr.replace(/\n/g, "").replace(/\s+/g, " ").trim();
    return cleanedStr;
  }

  useEffect(() => {
    if (htmlString.length > 0) {
      let cleanData = htmlString.map((item) => removeHTMLTags(item));
      setHtmlRemove(cleanData);
    }
  }, [htmlString]);
  return (
    <>
      {currentStatus?.status == "PENDING" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">
                Your request has been sent and we will respond as soon as
                possible
              </p>
            </div>
          </div>
        </>
      ) : currentStatus?.status == "ALLOWED" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">
                Your request is already accepted
              </p>
            </div>
          </div>
        </>
      ) : currentStatus?.status == "DENIED" ? (
        <>
          {" "}
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">Your request is denied</p>
            </div>
          </div>
        </>
      ) : htmlString.length < 2 ? (
        <>
          <div className="valuable-question-main-dev">
            {[0, 0, 0, 0, 0, 0, 0, 0].map((elem: number, index: number) => (
              <>
                <ShimmerLoaderwhite maxWidth="100vw" />
              </>
            ))}
          </div>
        </>
      ) : (
        <>
          <div className="valuable-question-main-dev">
            <div className="valuable-question-dev">
              <p className="valuable-question-title">
                Thank you for your request to talk to our CEO.
              </p>
              <p>
                To help us prepare for a focused and meaningful conversation,
                please complete the brief questionnaire below. We appreciate
                your time and look forward to speaking with you.
              </p>
            </div>
            {htmlString[0] && (
              <>
                {parser(htmlString[0])}
                <textarea
                  rows={4}
                  placeholder="Write your answer here "
                  id="story"
                  name="story"
                  onChange={(e) => handleChange(e, 0)}
                ></textarea>
                {errors[removeHtml[0]] && (
                  <p className="error-text">{errors[removeHtml[0]]}</p>
                )}
              </>
            )}
            {htmlString[1] && (
              <>
                {" "}
                {parser(htmlString[1])}
                <textarea
                  rows={4}
                  placeholder="Write your answer here "
                  id="story"
                  name="story"
                  onChange={(e) => handleChange(e, 1)}
                ></textarea>
                {errors[removeHtml[1]] && (
                  <p className="error-text">{errors[removeHtml[1]]}</p>
                )}
              </>
            )}
            {htmlString[2] && (
              <>
                {parser(htmlString[2])}
                <textarea
                  rows={4}
                  placeholder="Write your answer here "
                  id="story"
                  name="story"
                  onChange={(e) => handleChange(e, 2)}
                ></textarea>
                {errors[removeHtml[2]] && (
                  <p className="error-text">{errors[removeHtml[2]]}</p>
                )}
              </>
            )}
            {htmlString[3] && (
              <>
                {parser(htmlString[3])}
                <textarea
                  rows={4}
                  placeholder="Write your answer here "
                  id="story"
                  name="story"
                  onChange={(e) => handleChange(e, 3)}
                ></textarea>
                {errors[removeHtml[3]] && (
                  <p className="error-text">{errors[removeHtml[3]]}</p>
                )}
              </>
            )}
            {htmlString[4] && (
              <>
                {parser(htmlString[4])}
                <textarea
                  rows={4}
                  placeholder="Write your answer here "
                  id="story"
                  name="story"
                  onChange={(e) => handleChange(e, 4)}
                ></textarea>
                {errors[removeHtml[4]] && (
                  <p className="error-text">{errors[removeHtml[4]]}</p>
                )}
              </>
            )}
            <LoadingButton
              onClick={handleSubmit}
              style={{
                margin: "auto",
                width: "100%",
                fontFamily: "var(--Roboto-Regular)",
              }}
              variant="contained"
              color="primary"
              type="button"
              disabled={!isFormComplete || Object.values(errors).some((e) => e)}
              loading={btnLoading}
              loadingPosition="center"
            >
              SUBMIT
            </LoadingButton>
          </div>
          <div className="cricle-pro-dev">
            <Pie percentage={value} colour="rgba(74, 172, 0, 1)" />
          </div>
        </>
      )}
    </>
  );
};
export default Question;
